import Fancybox from '../../lib/FancyBox';

export default function FeatureCardSecond({
  title,
  description,
  duration,
  videoUrl,
  isNew,
  tag,
  iconSrc = '/placeholder.svg',
}) {
  return (
    <Fancybox>
      <a
        href={videoUrl}
        data-fancybox
        data-type="iframe"
        className="relative block w-full overflow-hidden rounded-[var(--rounded-xl,_12px)] p-4 hover:shadow-sm transition"
        aria-label={`${title} – Play video`}
      >
        {/* Image area */}
        <div
          className="relative flex items-center justify-center rounded-lg bg-[var(--q3-surface-dim)] w-full h-[197.561px] md:w-[336px] lg:w-[225.956px] md:h-[124px]"
          style={{
            aspectRatio: '360 / 197.56', // maintains aspect ratio
          }}
        >
          {/* Top badges */}
          {isNew && (
            <span className="absolute -top-2 left-2 bg-[var(--q3-danger-normal)] text-[var(--q3-neutral-default_inverted)] text-[10px] uppercase tracking-wider px-3 py-[2px] rounded-tl-[4px] rounded-bl-[4px] rounded-br-[4px] rounded-tr-[0px]">
              NEW FEATURE
              <span
                aria-hidden="true"
                style={{ clipPath: 'polygon(0 100%, 0 0, 100% 100%)' }}
                className="absolute -top-[0px] -right-[6px] w-[6px] h-[9px] bg-[var(--q3-rose-dark)]"
              />
            </span>
          )}
          {tag && (
            <span className="absolute top-2 right-2 inline-flex h-[17.118px] items-center gap-0 flex-shrink-0 rounded-[5.127px] border border-[var(--q3-stroke-light)] bg-[var(--q3-accent-light)] px-[3.424px] py-[3.424px] text-[10px] text-[var(--q3-accent-dark)] whitespace-nowrap">
              {tag}
            </span>
          )}

          {/* Icon image */}
          <img
            src={iconSrc}
            alt={`${title} icon`}
            aria-hidden="true"
            className="object-contain"
            style={{
              width: '59.912px',
              height: '59.912px',
              aspectRatio: '1 / 1',
              flexShrink: 0,
              marginTop: '20px',
            }}
          />

          {/* Subtle centered play button overlay */}
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-10 h-10 rounded-full bg-black/10 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="white"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="white"
                className="w-5 h-5"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 5.25v13.5l13.5-6.75-13.5-6.75z" />
              </svg>
            </div>
          </div>
        </div>

        {/* Text area below image */}
        <div className="mt-4 text-left">
          <h4 className="text-[16px] font-semibold leading-snug text-[var(--q3-neutral-default)]">{title}</h4>
          <p className="mt-[4px] text-[14px] leading-relaxed text-[var(--q3-neutral-light)]">{description}</p>
          <div className="mt-[6px] text-[12px] tracking-[0.12em] text-[var(--q3-neutral-light)]">{duration}</div>
        </div>
      </a>
    </Fancybox>
  );
}
